import { z } from 'zod';

/**
 * Package Type Master DTO.
 *
 * Backend endpoint: `/api/package-types`. Each row describes a physical
 * carrier (pallet, bulk bag, rack, …) used to weigh inbound material, plus
 * a default tare weight pre-filled when the operator selects it on the
 * inbound dialog.
 */

export const packageContainerClassValues = ['pallet', 'bulk_bag', 'rack', 'box', 'loose'] as const;
export type PackageContainerClass = (typeof packageContainerClassValues)[number];

export const packageTypeSchema = z.object({
  package_type_id: z.string(),
  type_code: z.string(),
  display_name: z.string(),
  container_class: z.enum(packageContainerClassValues),
  default_tare_kg: z.string(),
  sort_order: z.number().int().nullable().optional(),
  active_flag: z.boolean(),
});

export type PackageType = z.infer<typeof packageTypeSchema>;

export const packageTypeCreateSchema = z.object({
  type_code: z.string().min(1, 'コードを入力してください'),
  display_name: z.string().min(1, '表示名を入力してください'),
  container_class: z.enum(packageContainerClassValues),
  default_tare_kg: z
    .string()
    .min(1, '既定風袋を入力してください')
    .regex(/^\d+(\.\d{1,3})?$/, '0以上の数値（小数点3桁まで）を入力してください'),
  sort_order: z.coerce.number().int().min(0).optional(),
});

export type PackageTypeCreateInput = z.infer<typeof packageTypeCreateSchema>;
